<template>
    <div class="main main-padding new-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>活跃学生具体使用详情</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持场景编码、行为编码关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--活跃大屏具体使用详情-->
                <div class="table-wrapper-data">
                    <Table :columns="activeStudentDetailsColumn" :data="activeStudentDetailsList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import dateSelect from "../../../../components/dateSelect.vue";
    import {getStudentCodingKeyList} from "../../../../service/api.js";

    export default {
        name: "active-student-details",
        data () {
            return {
                schoolId: this.$route.query.schoolId,
                startTime: this.$route.query.selfStartDate,//上一个页面选择的开始时间
                endTime: this.$route.query.selfEndDate,//上一个页面选择的结束时间
                selfStartDate: this.$route.query.selfStartDate,
                selfEndDate: this.$route.query.selfEndDate,
                parentalStartDate: this.$route.query.parentalStartDate,//主页面选择的结束时间
                parentalEndDate: this.$route.query.parentalEndDate,//主页面选择的结束时间
                userId: this.$route.query.userId,
                schoolName: this.$route.query.schoolName,
                tabsName: this.$route.query.tabsName,//tab名称
                isShowRemind: this.$route.query.isShowRemind,//是否显示重复绑定
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,//页面数据总数
                pageCount: 0,//页数
                activeStudentDetailsColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户名称",
                        key: "fullName",
                        align: "center",
                    },
                    {
                        title: "场景编码",
                        key: "funcName",
                        align: "center",
                    },
                    {
                        title: "行为编码",
                        key: "clsName",
                        align: "center",
                    },
                    {
                        title: "动态数据",
                        key: "dynamic_data",
                        align: "center",
                    },
                    {
                        title: "次数",
                        key: "count",
                        align: "center",
                    }
                ],
                activeStudentDetailsList: [],//数据集合
            }
        },
        components: {
            dateSelect
        },
        methods: {
            /**
             *获取活跃学生具体使用详情数据
             */
            async getStudentCodingKeyList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.startTime,
                    endTime: _this.endTime,
                    userId: _this.userId,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getStudentCodingKeyList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.activeStudentDetailsList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                this.getStudentCodingKeyList();
            },
            /**
             * 搜索
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                this.getStudentCodingKeyList();
            },
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "dataDetailsTab",
                    query: {
                        schoolId: this.schoolId,
                        parentalStartDate: this.selfStartDate,//二级页面选择的开始时间
                        parentalEndDate: this.selfEndDate,//二级页面选择的结束时间
                        curSeleMainStartDate: this.parentalStartDate,//一级页面选择的开始时间
                        curSeleMainEndDate: this.parentalEndDate,//一级页面选择的结束时间
                        schoolName: this.schoolName,
                        tabsName: this.tabsName,
                        isShowRemind: this.isShowRemind,
                        type: 1
                    }
                });
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.page=1;
                this.startTime = startDate;
                this.endTime = endDate;
                this.getStudentCodingKeyList();
            },
        },
        mounted () {
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
            this.getStudentCodingKeyList();
            //记住页面选择的开始和结束时间
            this.$refs.dateSelect.setDate(this.selfStartDate, this.selfEndDate);
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";
</style>
<style lang="scss">
    .new-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
        }
        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }
        .ivu-row {
            margin-top: 0 !important;
        }
        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }
        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>

